export function joinIfTruthy(separator: string, ...strings: (string | null | undefined)[]) {
    return strings.filter(x => !!x).join(separator);
}
